(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
  // jQuery style exactly like your PDP code (delegated)
  $("#FAQToggles").on("click", ".FAQ-toggle-btn", function () {
    var $btn = $(this);
    var target = $btn.data("target");
    var $content = $(target);
    var isHidden = !$content.is(":visible");

    // update the clicked icon (not changing bg/text color)
    $btn.find(".FAQ-toggle-icon").text(isHidden ? "–" : "+");

    // close others and reset their icons
    $(".FAQ-toggle-content").not($content).slideUp(300);
    $(".FAQ-toggle-icon").not($btn.find(".FAQ-toggle-icon")).text("+");

    // smooth toggle the clicked one
    $content.stop(true, true).slideToggle(300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
